export enum ApplicationMode {
  Development = 'development',
}

export const isDevelopment = (): boolean => process.env.NODE_ENV === ApplicationMode.Development
